import {
  FDBox,
  FDDialogContent,
  FDSecondaryActionButton,
  FDStack,
} from '@facet-wealth/design';
import fr from 'facet-rest';
import { householdSecureFilesUri as advisorSecureFilesUri } from 'Consts/advisorUris';
import React from 'react';
import PropTypes from 'prop-types';
import { useSnackbarContext } from 'Context/SnackbarContext';
import { ViewableListItem } from 'Organisms/ViewableListItem/ViewableListItem';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';


const UploadedAccountStatementsView = ({ setUploadedAccountStatementDetailResource, setUploadedAccountStatementDetailIndex, uploadedAccountStatementsResource }) => {
  const { displayErrorMessage } = useSnackbarContext();

  const onStatementView = async (statement, idx) => {
    try {
      const [statementDetail] = await statement.relationship(fr.relationships.details.name).link('related').get();
      setUploadedAccountStatementDetailResource(statementDetail);
      setUploadedAccountStatementDetailIndex(idx);
    } catch (e) {
      if (e.errors) {
        displayErrorMessage(e, e.errors);
      } else {
        displayErrorMessage(e, 'Failed to view statement');
      }
    }
  };

  return (
    <FDStack direction={'column'}>
      <MetaControlField attr={'title'} />
      <FDDialogContent>
        <FDStack direction={'column'} spacing={4}>
          <MetaControlField attr={'subtitle'} />
          <FDStack direction={'column'} spacing={1}>
            {uploadedAccountStatementsResource.attr('statements').resources().list().map((statement, idx) => {
              return (
                <ViewableListItem
                  icon={statement.isTruthy('needsReview') ? 'warning' : ''}
                  iconColor={'warning'}
                  onView={() => onStatementView(statement, idx)}
                  itemText={statement.attr('statementName')}
                  canDelete={false}
                />
              );
            })}
          </FDStack>
          {
            uploadedAccountStatementsResource.withRelationship(fr.relationships.files.name,
              (rel) => (
                <FDBox>
                  <FDSecondaryActionButton
                    size={'lg'}
                    label={rel.meta('prompt')}
                    icon={'chevronRight'}
                    iconPosition={'end'}
                    href={advisorSecureFilesUri(rel.meta('householdId'))}
                    openInNewTab
                  />
                </FDBox>
              ),
              () => null)
          }
        </FDStack>
      </FDDialogContent>
    </FDStack>);
};

UploadedAccountStatementsView.propTypes = {
  setUploadedAccountStatementDetailResource: PropTypes.func.isRequired,
  setUploadedAccountStatementDetailIndex: PropTypes.func.isRequired,
  uploadedAccountStatementsResource: PropTypes.instanceOf(fr.Resource).isRequired,
};

UploadedAccountStatementsView.defaultProps = {
};

export default UploadedAccountStatementsView;
